import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useEffect, useRef } from 'react';
import { Box } from '@chakra-ui/react';
import * as echarts from 'echarts';
const DEFAULT_OPTIONS = {
    title: {
        padding: [0, 0, 0, 0],
        textStyle: {
            color: '#000',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 600,
            fontSize: '16px'
        }
    },
    grid: {
        top: 15,
        left: 60,
        right: 15,
        bottom: 40
    },
    xAxis: {
        type: 'value',
        nameLocation: 'center',
        nameGap: 30,
        nameTextStyle: {
            color: '#B3B3B3',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 400,
            fontSize: '11px'
        },
        axisLabel: {
            color: '#B3B3B3',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 400,
            fontSize: '11px'
        },
        axisLine: {
            show: true,
            lineStyle: {
                color: '#D1DCF3'
            }
        },
        axisTick: {
            show: true,
            lineStyle: {
                color: '#D1DCF3'
            }
        },
        splitLine: {
            show: false,
            lineStyle: {
                color: '#F1F4FC'
            }
        }
    },
    yAxis: {
        type: 'value',
        nameLocation: 'center',
        nameRotate: 90,
        nameGap: 50,
        nameTextStyle: {
            color: '#B3B3B3',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 400,
            fontSize: '11px'
        },
        axisLabel: {
            color: '#B3B3B3',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 400,
            fontSize: '11px'
        },
        axisLine: {
            show: false,
            lineStyle: {
                color: '#D1DCF3'
            }
        },
        axisTick: {
            show: false,
            lineStyle: {
                color: '#D1DCF3'
            }
        },
        splitLine: {
            show: true,
            lineStyle: {
                color: '#F1F4FC'
            }
        }
    }
};
const DEFAULT_SERIES_OPTIONS = {
    type: 'line',
    symbol: 'circle',
    symbolSize: 8,
    lineStyle: {
        color: '#3B568C'
    },
    itemStyle: {
        color: '#3B568C'
    }
};
const LineChartPointsResultFC = ({ data, height }) => {
    const chartContainerRef = useRef(null);
    const chartRef = useRef(null);
    useEffect(() => {
        if (chartContainerRef.current) {
            chartRef.current = echarts.init(chartContainerRef.current);
            chartRef.current.setOption({
                ...DEFAULT_OPTIONS,
                title: { ...DEFAULT_OPTIONS.title, text: data.title, show: !!data.title },
                grid: { ...DEFAULT_OPTIONS.grid, top: data.title ? 55 : DEFAULT_OPTIONS.grid.top },
                xAxis: { ...DEFAULT_OPTIONS.xAxis, name: data.xAxisName },
                yAxis: { ...DEFAULT_OPTIONS.yAxis, name: data.yAxisName },
                series: data.series.map((seriesItem) => ({ ...seriesItem, ...DEFAULT_SERIES_OPTIONS }))
            });
        }
    }, [data]);
    return (_jsx(Box, { width: '100%', ref: chartContainerRef, height: height ? `${height}px` : '100%', "data-testid": "LineChartPointsResult-test" }));
};
export const LineChartResult = memo(LineChartPointsResultFC);
//# sourceMappingURL=LineChartResult.js.map